<template>
    <div>
        <form class="card card-sm" id="main-form" action="" method="post">
            <div class="card-body row no-gutters align-items-center search_form">
                <div class="col">
                    <slot></slot>
                    <div id="div_id_url" class="form-group">
                        <div class="position-relative">
                            <input
                                @keydown="enterClick"
                                v-model="input"
                                @change="change"
                                @input="onInput"
                                type="text"
                                name="url"
                                :placeholder="inputPlaceholder"
                                autofocus="true"
                                class="textinput textInput form-control pr-5"
                                required
                                id="id_url">
                            <img
                                v-if="input && input.length > 0"
                                src="/img/form-close.svg"
                                alt="Очистить"
                                class="clear-input-icon"
                                @click="clearInput"
                                style="cursor: pointer;"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-auto desktop-button">
                    <button
                        class="btn btn-lg btn-danger searchButton"
                        type="submit"
                        id="search"
                        @click.prevent="submit"
                    >
                        <span class="d-none d-md-inline">{{ startButton }}</span>
                        <i class="fas fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>
        <div v-if="linkError" role="alert" class="link-error-msg">{{ errorMessage }}</div>
        <div class="mobile-button">
            <button
                class="btn btn-lg btn-danger mobile-search-button"
                type="button"
                id="mobile-search"
                @click="submit"
            >
                <span>{{ startButton }}</span>
                <i class="fas fa-arrow-right"></i>
            </button>
        </div>
    </div>
</template>

<script>
import validUrl from "../tools/validUrl";
import uaParser from 'ua-parser-js';
import { isInstagramContent, isInstagramContext, isProfileLink } from '../tools/instagramLinks';

export default {
    props: ['inputPlaceholder', 'errorMessage', 'startButton'],
    data() {
        return {
            input: null,
            previousInput: null,
            hls: false,
            processing: false,
            isInstagram: false,
            linkError: false,
        }
    },
    mounted() {
        this.isInstagram = window?.location.pathname?.includes('instagram') || window?.location?.href.includes('instagram')
        if (localStorage.getItem("search")) {
            this.input = localStorage.getItem("search");
            this.isInstagram ||= this.input[0] === '@'
            localStorage.removeItem("search");
            setTimeout(() => {
                this.change();
                this.submit();
            }, 100);
        }
        this.$root.$on('link-cast', (link) => {
            this.input = link;
            this.submit();
        });

        this.$root.$on('result-end', () => {
            this.processing = false;
        });

        const agent = new uaParser();
        const device = agent.getDevice();
        if (device.type === 'mobile' && window.innerHeight > 400) {
            const input = document.getElementById("id_url");
            input.blur();
            input.addEventListener("focus", () => {
                const iframe = document.querySelector("html > iframe");
                if (iframe) {
                    iframe.style.display = "none";
                }
            })
            input.addEventListener("click", () => {
                const iframe = document.querySelector("html > iframe");
                if (iframe) {
                    iframe.style.display = "none";
                }

            })
            input.addEventListener("blur", () => {
                const iframe = document.querySelector("html > iframe");
                if (iframe) {
                    iframe.style.display = "block";
                }
            })
        }
        const pathname = document.location.pathname;

    },
    methods: {
        enterClick(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                this.submit();
            }
        },
        clearInput() {
            this.input = '';
            this.linkError = false;
            this.previousInput = null;
            this.$nextTick(() => {
                this.$el.querySelector('#id_url').focus();
            });
        },
        submit() {
            if (this.hls) {
                return;
            }
            if (typeof this.input !== 'string') {
                return
            }
            this.input = this.input.trim()

            if (this.input === '') {
                return
            }
            this.handleSubmit(this.input)
        },
        change() {
            const input = this.input.trim();
            this.handleSubmit(input)
        },
        onInput(event) {
            const input = this.input.trim()
            this.isInstagram = isInstagramContext(input)
            this.linkError = false

            if (
                event.inputType === 'insertFromPaste' ||
                event.inputType === 'insertFromDrop' ||
                event.inputType === 'insertFromYank'
            ) {
                this.handleSubmit(input)
            }
        },
        handleSubmit(input){
                // поле принимает только ссылку на видео
                input = input.trim()
                const contentLink = isInstagramContent(input)

                if(this.previousInput === input) {
                    return;
                }

                this.previousInput = input
                this.linkError = false
                this.$root.$emit('clear-results')

                if(contentLink){
                    this.$root.$emit('link-submit', input);
                } else if(isInstagramContext(input) || isProfileLink(input)) {
                    // профиль инстаграма или ник (@username / instagram.com/username) — просмотр профиля.
                    // Проверяем ДО validUrl: instagram.com/username проходит validUrl, но должен идти в профиль, а не в скачивание.
                    this.$root.$emit('search-request', input);
                } else if(validUrl(input)) {
                    this.$root.$emit('link-submit', input);
                } else {
                    // не-ссылка: показываем ошибку под полем в стиле «вставьте ссылку».
                    // previousInput сбрасываем, чтобы дедупликация не подавила повторную
                    // попытку: и тот же невалидный текст должен снова показать ошибку,
                    // и ранее валидная ссылка должна переотправиться (её результаты уже
                    // очищены через clear-results выше).
                    this.previousInput = null;
                    this.linkError = true;
                }
            },
    }
}
</script>

../tools/instagramLinks
